import { render, staticRenderFns } from "./painel_paciente.vue?vue&type=template&id=1eb09d44&"
import script from "./painel_paciente.vue?vue&type=script&lang=js&"
export * from "./painel_paciente.vue?vue&type=script&lang=js&"
import style0 from "./painel_paciente.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports